/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { StatusResponse } from './';
import {
    StatusResponseFromJSON,
    StatusResponseFromJSONTyped,
    StatusResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchReferralSubmissionRequest
 */
export interface SearchReferralSubmissionRequest {
    /**
     * The page number
     * @type {number}
     * @memberof SearchReferralSubmissionRequest
     */
    page: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof SearchReferralSubmissionRequest
     */
    itemsPerPage?: number;
    /**
     * 
     * @type {Array<StatusResponse>}
     * @memberof SearchReferralSubmissionRequest
     */
    statuses?: Array<StatusResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchReferralSubmissionRequest
     */
    countries?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchReferralSubmissionRequest
     */
    businessUnits?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchReferralSubmissionRequest
     */
    salesManagers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchReferralSubmissionRequest
     */
    communityManagers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchReferralSubmissionRequest
     */
    countryManagers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SearchReferralSubmissionRequest
     */
    submissionId?: string;
}

/**
 * Check if a given object implements the SearchReferralSubmissionRequest interface.
 */
export function instanceOfSearchReferralSubmissionRequest(value: object): value is SearchReferralSubmissionRequest {
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function SearchReferralSubmissionRequestFromJSON(json: any): SearchReferralSubmissionRequest {
    return SearchReferralSubmissionRequestFromJSONTyped(json, false);
}

export function SearchReferralSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchReferralSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'] == null ? undefined : json['itemsPerPage'],
        'statuses': json['statuses'] == null ? undefined : ((json['statuses'] as Array<any>).map(StatusResponseFromJSON)),
        'countries': json['countries'] == null ? undefined : json['countries'],
        'businessUnits': json['businessUnits'] == null ? undefined : json['businessUnits'],
        'salesManagers': json['salesManagers'] == null ? undefined : json['salesManagers'],
        'communityManagers': json['communityManagers'] == null ? undefined : json['communityManagers'],
        'countryManagers': json['countryManagers'] == null ? undefined : json['countryManagers'],
        'submissionId': json['submissionId'] == null ? undefined : json['submissionId'],
    };
}

export function SearchReferralSubmissionRequestToJSON(value?: SearchReferralSubmissionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
        'statuses': value['statuses'] == null ? undefined : ((value['statuses'] as Array<any>).map((v) => StatusResponseToJSON(v))),
        'countries': value['countries'],
        'businessUnits': value['businessUnits'],
        'salesManagers': value['salesManagers'],
        'communityManagers': value['communityManagers'],
        'countryManagers': value['countryManagers'],
        'submissionId': value['submissionId'],
    };
}

